import { Utils } from '../../../common/views/Utils';
import { ShortInvoiceModel } from '../../models/InvoiceModel';
import { styles } from "../../../common/views/DefaultStyles";
import { ProductUtils } from '../../../products/ProductUtils';
import { ShortOrderItemModel } from '../../../orders/models/OrderModel';
import { OrderUtils } from '../../../orders/views/shared/OrderUtils';
import { Icon } from '@fluentui/react';
import moreIcon from "../../../../assets/images/more.png";

export type InvoiceOrderListProps = {
    invoice: ShortInvoiceModel;
}

export default function InvoiceOrderListView({ invoice }: InvoiceOrderListProps) {
    const width3 = Utils.getColumnWidth(3);
    const itemCount = invoice.items.length;
    const items = itemCount <= 8 ? invoice.items : invoice.items.slice(0, 7);

    return <div>
        {items.map((item: ShortOrderItemModel, index: number) => {
            let url = ProductUtils.getImageUrl(item.imageUrl);

            return <div key={item.id} className="pv-5" style={{ width: "22%", display: "inline-flex" }}>
                {OrderUtils.image(url, item.qty, 50, 0, false)}
            </div>
        })}

        {itemCount > 8 &&
            <div className="center pv-5" style={{ width: "22%", display: "inline-block" }}>
                <img src={moreIcon} width={40} height={40} />
            </div>}
    </div>
}